var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var LIBRARY_PATHS = ["/home", "/feed/", "/u/", "/collection/"];
var onLibraryPage = function () {
    return LIBRARY_PATHS.some(function (p) { return window.location.pathname.startsWith(p); });
};
function NavLink(_a) {
    var href = _a.href, children = _a.children, className = _a.className;
    var handleClick = function (e) {
        if (onLibraryPage()) {
            e.preventDefault();
            window.history.pushState(null, "", href);
        }
    };
    return (_jsx("a", __assign({ href: href, onClick: handleClick, className: className }, { children: children })));
}
export default NavLink;
